import React, { useContext } from 'react';
import { ThemeContext } from '../context/theme-context';
import styles from '../styles/About.module.css';
import headerStyles from '../styles/Header.module.css';
import { handleCVDownload } from './util.js'
import {
    FaEnvelope,
    FaPhone,
    FaMapMarkerAlt,
    FaGithub,
    FaLinkedin,
    FaTwitter, FaFileDownload ,FaSkype, FaWhatsapp, FaGoogle,
    FaCode,
    FaLaptopCode,
    FaTerminal
} from 'react-icons/fa';
import {
    SiCodemagic,
    SiHiveBlockchain
} from 'react-icons/si';
import aboutStyles from "../styles/About.module.css";

function About() {
    const { theme } = useContext(ThemeContext);

    const socialLinks = [
        {
            icon: <FaLinkedin />,
            href: 'https://be.linkedin.com/in/leeroy-msizi-kamafu-5a01a899',
            label: 'LinkedIn'
        },
        {
            icon: <FaSkype />,
            href: 'https://teams.microsoft.com/l/chat/0/0?users=leeroy.ncube4',
            label: 'Skype'
        },
        {
            icon: <FaWhatsapp />,
            href: 'https://wa.me/+32498060528',
            label: 'WhatsApp'
        },
        {
            icon: <FaGoogle />,
            href: 'mailto:ncubelee04@gmail.com',
            label: 'GMail'
        }
    ];

    // Array of programming/tech icons
    const TechIcons = [
        FaCode,
        FaLaptopCode,
        FaTerminal,
        SiCodemagic,
        SiHiveBlockchain
    ];

    // Randomly select an icon based on theme
    const SelectedIcon = TechIcons[
        theme === 'light'
            ? Math.floor(Math.random() * TechIcons.length)
            : Math.floor(Math.random() * TechIcons.length)
        ];

    const personalDetails = [
        {
            icon: <FaEnvelope className={styles.detailIcon} />,
            text: 'ncubelee04@gmail.com',
        },
        {
            icon: <FaPhone className={styles.detailIcon} />,
            text: '+32 498 06 05 28'
        },
        {
            icon: <FaMapMarkerAlt className={styles.detailIcon} />,
            text: 'Aalst, Belgium'
        }
    ];

    return (
        <section
            id="about"
            className={styles.aboutSection}
            data-theme={theme}
        >
            <div className="container">
                <div className={styles.aboutContent}>

                    <div className={headerStyles.headerContent}>
                        <div className={headerStyles.headerTextContainer}>
                            <h1 className={headerStyles.headerTitle}>
                                Leeroy Msizi Ncube
                            </h1>
                            <h2 className={headerStyles.headerSubtitle}>
                                Senior Software Engineer
                            </h2>
                            <div className={styles.personalDetails}>
                                {personalDetails.map((detail, index) => (
                                    <div key={index} className={styles.detailItem}>
                                        {detail.icon}
                                        <span className={styles.detailText}>
                    {detail.text}
                  </span>
                                    </div>
                                ))}
                            </div>
                            <p className={headerStyles.headerDescription}>
                                Java microservices expert adept at crafting scalable solutions with Spring Boot, AWS,
                                and
                                Kubernetes. <br/> Specializes in modern JavaScript technologies, with a focus on Angular
                                &
                                React.<br/>
                                Driven by clean code, CI/CD automation, and cutting-edge technology.
                            </p>

                            <div className={headerStyles.headerCta}>
                                <a
                                    href="#contact"
                                    className={`${headerStyles.ctaButton} ${headerStyles.primaryButton}`}
                                >
                                    Hire Me
                                </a>
                                <button
                                    onClick={handleCVDownload}
                                    className={`${headerStyles.ctaButton} ${headerStyles.secondaryButton}`}
                                    aria-label="Download CV"
                                >
                                    <FaFileDownload style={{marginRight: '0.5rem'}}/>
                                    Download CV
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={styles.aboutImage}>
                        <div className={styles.imageWrapper}>
                            <img
                                src="https://d2fcmuoyu5hsuu.cloudfront.net/dp.png"
                                alt="Leeroy Ncube Profile"
                            />
                        </div>
                        <div className={styles.socialLinks}>
                            {socialLinks.map((link, index) => (
                                <a
                                    key={index}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.socialLink}
                                    aria-label={link.label}
                                >
                                    {link.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;